import { ToolCategory } from "../types";

export const categories: ToolCategory[] = [
  {
    id: "loans",
    name: "Loan & Credit",
    description: "Mortgages, personal loans, auto loans, credit card payoffs, and debt consolidation calculators.",
    icon: " Landmark"
  },
  {
    id: "savings",
    name: "Savings & Investments",
    description: "Compound interest, SIP calculators, passive income, and mutual fund growth models.",
    icon: "Coins"
  },
  {
    id: "retirement",
    name: "Retirement",
    description: "FIRE planning, 401(k) projections, pensions, social security estimators, and future budgeting.",
    icon: "HeartHandshake"
  },
  {
    id: "budget",
    name: "Budget & Expenses",
    description: "Monthly expense tracking, rent affordability, cost of living, and emergency fund target models.",
    icon: "Wallet"
  },
  {
    id: "tax",
    name: "Taxes",
    description: "Income tax sheets, capital gains calculations, sales taxes, property taxes, and refunds.",
    icon: "Receipt"
  },
  {
    id: "income",
    name: "Income & Salaries",
    description: "Hourly-to-salary calculators, overtime logs, side hustle profits, and take-home pay structures.",
    icon: "Briefcase"
  },
  {
    id: "banking",
    name: "Banking & CDs",
    description: "Certificate of deposit (CD) ladders, high-yield options, and simple/periodic banking returns.",
    icon: "Building"
  },
  {
    id: "networth",
    name: "Net Worth & Independence",
    description: "Asset allocations, debt-to-income indicators, and wealth velocity calculators.",
    icon: "ShieldAlert"
  },
  {
    id: "insurance",
    name: "Insurance",
    description: "Estimated healthcare, disability, term life, home, and auto insurance coverage premiums.",
    icon: "Shield"
  }
];
